export enum Size {
    Large,
    Medium,
    Small,
}
